function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useEffect } from 'react';
import EmptyState from "../../EmptyState/EmptyState";
import { useStore, useStoreActions } from "../../../contexts";
import { selectors } from "../../../store/state-selectors";
import RestfulWrapper from "../../RestfulWrapper/RestfulWrapper";
import InvoicesTable from "../../InvoicesTable/InvoicesTable";
import MinisiteTabHeader from "../MinisiteTabHeader/MinisiteTabHeader";
import styles from "./InvoicesView.module.scss";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
export function ActualInvoicesView(props) {
  const {
    invoices,
    scrollEl,
    refreshInvoices,
    refreshAgreement
  } = props;
  const showQboIntegration = useStore(selectors.integration.showQboIntegration);
  const {
    fetchIntegrations
  } = useStoreActions();
  useEffect(() => {
    if (showQboIntegration) {
      fetchIntegrations();
    }
  }, [showQboIntegration]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MinisiteTabHeader, null), /*#__PURE__*/React.createElement("div", {
    className: styles.container,
    "data-testid": "agreement-invoices-view"
  }, invoices.length > 0 ? /*#__PURE__*/React.createElement(InvoicesTable, {
    invoices: invoices,
    scrollEl: scrollEl,
    filtersClassname: styles.filters,
    retry: async () => {
      await Promise.all([refreshInvoices(), refreshAgreement({
        silent: true
      })]);
    }
  }) : /*#__PURE__*/React.createElement(EmptyState, {
    testid: "invoices-view-empty-state",
    illustration: "invoices",
    paragraphs: ['Invoices are automatically generated according to the terms of each agreement.', 'No invoices have been generated for this agreement yet.']
  })));
}
export default function InvoicesView(props) {
  const {
    api
  } = useStoreActions();
  const {
    USE_INVOICE_VIEWS = false
  } = useFeatureFlags();
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: () => USE_INVOICE_VIEWS ? api.invoice.getSummariesScout(props.agreement.id) : api.invoice.getSummaries(props.agreement.id),
    renderChild: _ref => {
      let {
        data,
        loading,
        refresh
      } = _ref;
      return /*#__PURE__*/React.createElement(ActualInvoicesView, _extends({}, props, {
        invoices: data,
        isLoading: loading,
        refreshInvoices: refresh
      }));
    }
  });
}